import { Component, Input } from '@angular/core';
import { Encoding } from '@mode-vegas/vegas';
import { SelectedChartService } from '@mode/charts/contract';
import { ChartTypes, FlamingoTypes } from '@mode/shared/contract-common';
import { FieldDropHandlerService } from '../cartesian-builder-common/field-drop-handler.service';
import { ComboDropHandlerService } from './combo-drop-handler.service';

@Component({
  selector: 'mode-combo-builder',
  templateUrl: './combo-builder.component.html',
  providers: [{ provide: FieldDropHandlerService, useClass: ComboDropHandlerService }],
})
export class ComboBuilderComponent {
  @Input({ required: true }) encoding!: Encoding;
  @Input() observables: any;
  @Input({ required: true }) chartService!: SelectedChartService;
  @Input({ required: true }) model!: FlamingoTypes.ModeModel;
  @Input() isExploring = false;
  @Input({ required: true }) chartType!: ChartTypes.ChartType;
}
